import { element } from 'angular';
var hiddenAttribute = 'hidden';
var diretiveTemplate = "\n  <div class=\"favourites-full__container\">\n    <div class=\"favourites-full__overlay\" ng-click=\"close()\"></div>\n    <div class=\"favourites-full\" ng-include=\"'compatibilityguide/ng-templates/feature/favourites/viewfavouritesfull'\"></div>\n  </div>\n";
export var ViewFavouritesFullDirective = [
    '$rootScope',
    '$compile',
    '$timeout',
    'favouritesService',
    function ($rootScope, $compile, $timeout, favouritesService) {
        return {
            link: function ($scope, $element) {
                var masterContent = element('.master__content');
                var compiledHtml;
                var favouritesFullContainer;
                var isShown = false;
                $scope.searchResultLimit = 3;
                $scope.solutionLimit = 3;
                $scope.solutionsExpanded = false;
                $scope.searchResultsExpanded = false;
                $scope.close = function () {
                    isShown = false;
                    if (!favouritesFullContainer) {
                        return;
                    }
                    favouritesFullContainer.remove();
                    masterContent.attr(hiddenAttribute, null);
                    $rootScope.$broadcast('favourites:fullhidden');
                };
                $scope.expand = function (section) {
                    if (section === void 0) { section = ''; }
                    switch (section.toLowerCase()) {
                        case 'solutions':
                            $scope.solutionLimit = $scope.favourites.solutions.length;
                            $scope.solutionsExpanded = true;
                            break;
                        case 'searchresults':
                            $scope.searchResultLimit = $scope.favourites.searchResults.length;
                            $scope.searchResultsExpanded = true;
                            break;
                        default:
                            break;
                    }
                };
                $rootScope.$on('favourites:changed', function (event, favourites) {
                    $scope.favourites = favourites;
                });
                $rootScope.$on('favourites:fullhide', function () {
                    $scope.close();
                });
                $scope.remove = function (pageUrl) {
                    favouritesService.remove(pageUrl);
                };
                $element.on('click', function () {
                    if (isShown) {
                        return;
                    }
                    $rootScope.$broadcast('favourites:fullshown');
                    isShown = true;
                    $scope.favourites = favouritesService.getFavourites();
                    $scope.searchResultsExpanded = $scope.favourites.searchResults.length <= $scope.searchResultLimit;
                    $scope.solutionsExpanded = $scope.favourites.solutions.length <= $scope.solutionLimit;
                    compiledHtml = $compile(diretiveTemplate)($scope);
                    element('.master__view').append(compiledHtml);
                    favouritesFullContainer = element('.favourites-full__container');
                    masterContent.attr(hiddenAttribute, '');
                    $timeout(function () {
                        $scope.$apply();
                    }, 0);
                });
                $scope.$on('$destroy', function () {
                    $element.off('click');
                });
            },
            restrict: 'E',
        };
    },
];
